// extracted by mini-css-extract-plugin
export default {"container":"custom-mobile-pagination_container__zwZpj","backImg":"custom-mobile-pagination_backImg__pDCk1"};